import React, { Fragment } from 'react';
import { bool } from 'prop-types';
import { Accordion } from 'propulsion-rc-v2';
import { trackHeapEvent } from '../../../../shared_modules/custom-heap-tracking-attributes';
import { DISCLAIMER_SYMBOL } from '../../../../shared_modules/baui-constants/symbols';

const JointFaqPanels = () => {
  const faqAccordionData = [
    {
      id: 'panel-1',
      header: 'Why should I consider a joint loan?',
      details: (
        <div>
          When you apply jointly, we review your combined finances instead of your individual financial history, which
          could help you get a larger loan amount
          {DISCLAIMER_SYMBOL.THREE} and a better interest rate.
          {DISCLAIMER_SYMBOL.TWO} Whether you’re looking to tackle shared or individual debt, a joint loan is often a
          smart way to pay it down and save money
          {DISCLAIMER_SYMBOL.ONE}
          —and you can be more confident about getting approved.
        </div>
      ),
    },
    {
      id: 'panel-2',
      header: 'Who should I consider applying with?',
      details: (
        <div>
          Many members apply with a family member or friend, but it’s up to you! Your relationship to your co-borrower
          has no impact on your offer. It’s most important to apply with someone you trust and know well—and ideally
          someone who has similar or better financial standing.
        </div>
      ),
    },
    {
      id: 'panel-3',
      header: 'How does a joint loan affect my co-borrower?',
      details: (
        <div>
          <p>
            Checking your rate for a joint loan through LendingClub has absolutely no impact on your or your
            co-borrower’s credit scores. A soft credit pull is used to see what you could qualify for, which is only
            visible to you or your co-borrower, respectively. A hard credit pull that could impact your or your
            co-borrower’s credit score will occur only if you decide to continue with your loan and the money is sent to
            your account.
          </p>
          <p>
            The good news is that a personal loan could also positively affect your and your co-borrower’s credit scores
            down the road. You can demonstrate a history of on-time payments and reduce your total debt (as long as you
            don’t add new debt, like increased credit card balances).
          </p>
          <p>
            Best of all, a joint loan allows you to pay down your own individual debt, your co-borrower’s individual
            debt, shared debt, or a combination of all three.
          </p>
        </div>
      ),
    },
    {
      id: 'panel-4',
      header: 'How does applying jointly change the interest rate or loan size I could qualify for?',
      details: (
        <div>
          Applying jointly could help you increase your loan amount by 41%,
          {DISCLAIMER_SYMBOL.THREE} so you can pay down even more debt. Many members with joint loans also save over
          $620 dollars
          {DISCLAIMER_SYMBOL.ONE} and get a lower APR compared to individual borrowers.
          {DISCLAIMER_SYMBOL.TWO}
        </div>
      ),
    },
  ];

  const trackFAQClick = (id, isExpanded) => {
    const section = faqAccordionData.find(element => element.id === id);
    trackHeapEvent(`FAQ question ${isExpanded ? 'open' : 'close'}`, section.header);
  };

  return (
    <div className="joint-faq-panels">
      <div className="title">Common Questions</div>
      <Accordion onChange={trackFAQClick} panelWrapperClassName="joint-faq-panel" data={faqAccordionData} />
    </div>
  );
};

const JointFaqDisclaimers = ({ showAddonJointDisclaimer }) => (
  <div className="joint-faq-disclaimer">
    {showAddonJointDisclaimer && (
      <p>
        By choosing a joint application, the two of you agree that you are applying for credit together and will be
        equally responsible for the loan. All legal documents and disclosures must be signed by each applicant
        individually.
      </p>
    )}
    <p>
      {DISCLAIMER_SYMBOL.ONE} Savings compares the total cost of a $14,300 loan (the average loan size through
      LendingClub) at the average joint APR of 19.34% to the same loan amount at the average individual APR of 21.13%.
      Data is from 6/1/19–9/30/19 and does not include partner channel. All applicants may apply individually or jointly
      based on their preference.
    </p>
    <p>
      {DISCLAIMER_SYMBOL.TWO} APR discount compares the average individual APR of 21.13% to the average joint APR of
      19.34%. Data is from 6/1/19–9/30/19 and does not include partner channel. All applicants may apply individually or
      jointly based on their preference.
    </p>
    <p>
      {DISCLAIMER_SYMBOL.THREE} Loan size difference compares the average individual loan amount of $13,418 to the
      average joint loan amount of $18,949, for a difference of $5,531 or 41.2%. Data is from 6/1/19-9/30/19 and does
      not include partner channel. All applicants may apply individually or jointly based on their preference.
    </p>
  </div>
);

JointFaqDisclaimers.propTypes = {
  showAddonJointDisclaimer: bool,
};

JointFaqDisclaimers.defaultProps = {
  showAddonJointDisclaimer: false,
};

// TODO: fix the prop name here. Right now the way this is worded, if we set showPatriotActDisclosures
// to true, we are actually hiding it. By default, we are showing the div that showPatriotActDisclosures is
// safe guarding right now.
const JointFaq = props => (
  <Fragment>
    <JointFaqPanels />
    <JointFaqDisclaimers showAddonJointDisclaimer={!props.showPatriotActDisclosures} />
  </Fragment>
);

JointFaq.propTypes = {
  showPatriotActDisclosures: bool,
};

JointFaq.defaultProps = {
  showPatriotActDisclosures: false,
};

export default JointFaq;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/JointFaq/JointFaq.scss');